import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';

// Used 7x across 7 files (+ 3 more with key order reversed) — Avatar with primary palette background
export const PrimaryAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));

// Used 6x across 6 files — TopBar person-icon Avatar: fixed 45×45, bold initial, primary colours
export const PersonIconAvatar = styled(Avatar)(({ theme }) => ({
  width: 45,
  height: 45,
  fontSize: 18,
  fontWeight: 'bold',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));
